import styled from "styled-components";

import { Button } from "components/Button";
// import { upgradePlanImage } from "assets/images";
import { Card } from "react-bootstrap";

export const SidebarContainer = styled.div`
  position: absolute;
  left: 0;
  z-index: 1031;
  width: 240px;
  transition: width 0.5s ease;
  height: 100%;
  background: ${({ theme }) => theme.global.bg.auth};

  .link-logo {
    height: 60px;
    display: flex;
    margin-left: 15px;

    .main-logo {
      cursor: pointer;
      max-width: 185px;
      max-height: 100px;
      margin-top: 18px;
      padding: 0px 0px 0px 0px;
    }
  }

  &.collapsed {
    width: 60px;

    .sidebar
      .sidebar-inner
      .sidebar-layout
      .sidebar-footer
      .sidebar-btn-wrapper {
      padding: 20px 2px;

      .sidebar-btn {
        padding: 0;

        span {
          font-size: 11px;
        }
      }
    }
  }

  .sidebar {
    position: relative;
    color: ${({ theme }) => theme.global.extraInfo.font.color};
    height: 100%;

    .sidebar-inner {
      border-right: 1px solid ${({ theme }) => theme.global.border.tertiary};
      border-bottom: none;
      position: relative;
      height: 100%;

      .sidebar-layout {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        position: relative;

        .sidebar-content {
          flex-grow: 1;

          .menu {
            padding: 10px;
          }
        }

        .sidebar-footer {
          border-top: none;
          text-align: center;

          .sidebar-btn-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;

            .sidebar-btn {
              transition: width 0.3s;
              width: 150px;
              padding: 1px 15px;
              ${({ theme }) => theme.constants.BORDER_RADIUS_8};
              color: ${({ theme }) => theme.aside.button.color};
              text-decoration: none;
              margin: 0 auto;
              height: 35px;
              display: flex;
              align-items: center;
              justify-content: center;
              text-overflow: ellipsis;
              overflow: hidden;

              .version {
                font-weight: 500;
                line-height: 140%;
                opacity: 0.5;
                font-size: 13px !important;
                color: ${({ theme }) => theme.aside.font.color};
              }

              &:hover {
                color: ${({ theme }) => theme.aside.button.hover};
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    margin-left: 0px;
    background: ${({ theme }) => theme.card.bg.tableHeader};
    backdrop-filter: blur(25px);
    border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_18};
    left: -240px;
    transition: left 0.5s ease;
    z-index: 1030;
    height: 100vh;

    &.collapsed {
      left: 0;
      width: 230px;
    }

    .sidebar .sidebar-inner {
      height: 100%;
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_18};

      .sidebar-layout {
        .sidebar-content {
          margin-top: 20px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .account-header {
      display: flex;
      align-items: center;
      gap: 6px;

      .link-logo {
        height: auto;
      }

      .main-logo {
        height: 40px;
        width: 40px;
      }

      .item-content {
        font-weight: 500;
        font-size: 14px;
        line-height: 140%;
        flex-grow: 1;
        flex-shrink: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
      }
    }

    .sidebar-account-layout {
      .close-menu {
        display: block;
        position: absolute;
        bottom: 20px;

        &.active {
          .inner-item {
            background-color: transparent !important;
            border: 0px !important;

            img {
              height: 24px;
            }
          }
        }
      }
    }
  }
`;

export const RecommendCardContainer = styled(Card)`
  margin: 0px 8px;
  border-radius: 12px;
  background: var(--Colors-Gray-modern-200, #e3e8ef);
  border: 0;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0.5rem;
  padding: 16px;
  min-height: 120px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.03);
  }

  .upgrade-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    gap: 12px;
  }

  .upgrade-text {
    flex: 1;
    text-align: left;

    .upgrade-title {
      font-size: 14px;
      font-weight: 500;
      color: var(--colors-text-text-secondary-700, rgba(10, 13, 18, 0.7));
      margin: 0 0 4px 0;
      line-height: 1.3;
    }

    .upgrade-description {
      font-size: 11px;
      margin: 0;
      line-height: 1.4;
      color: var(--colors-text-text-tertiary-600, #535862);
    }
  }

  .upgrade-visual {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-shrink: 0;
  }

  .placeholder-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ffd700 0%, #ffa500 100%);
    display: flex;
    align-items: center;
    justify-content: center;

    .surmount-logo {
      font-size: 18px;
      font-weight: bold;
      color: #fff;
    }
  }

  .arrow-button {
    width: 28px;
    height: 28px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 6px;
    border: 1px solid #d5d7da;
    background: #fff;
    box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
      0 -2px 0 0 rgba(10, 13, 18, 0.05) inset,
      0 1px 2px 0 rgba(10, 13, 18, 0.05);

    svg {
      color: #666;
    }
  }

  @media (max-width: 768px) {
    &.account-recommend-card {
      display: none;
    }

    .upgrade-content {
      gap: 8px;
    }

    .upgrade-text {
      .upgrade-title {
        font-size: 13px;
      }

      .upgrade-description {
        font-size: 10px;
      }
    }

    .placeholder-image {
      width: 36px;
      height: 36px;

      .surmount-logo {
        font-size: 16px;
      }
    }

    .arrow-button {
      width: 22px;
      height: 22px;

      svg {
        width: 14px;
        height: 14px;
      }
    }
  }
`;

export const CreateStrategyIcon = styled(Button)`
  padding: 6px !important;
  width: 100%;
`;

export const AppMenuContainer = styled.div`
  @keyframes slideInFade {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .close-menu {
    display: none;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;

    .menu-item {
      opacity: ${({ theme }) => theme.aside.opacity};
      margin-top: 0;
      margin-bottom: 10px;
      .icon-wrapper-3 .icon svg {
        fill: #fff;
      }

      .inner-item {
        .item-content {
          color: #414651 !important;
        }
      }

      &:hover {
        opacity: 1;

        .item-content {
          color: #2258f1 !important;

          .chevron svg {
            stroke: #2258f1;
          }
        }

        .icon-wrapper .icon svg {
          stroke: #2258f1;

          &.create-strategy {
            stroke: #2258f1;
          }
        }
      }

      &:first-child {
        margin-top: 20px;

        .inner-item {
          padding: 8px 13px;
        }
      }

      &.helpcenter-toggle {
        position: absolute;
        margin-bottom: 0;
        bottom: 3em;
      }

      &.active {
        opacity: 1;

        .inner-item {
          border-radius: 25px;

          .item-content {
            color: #2258f1 !important;

            .chevron svg {
              stroke: #2258f1;
            }
          }
          .icon-wrapper .icon svg {
            stroke: #2258f1;

            &.create-strategy {
              stroke: #2258f1;
            }
          }
        }
      }

      &.sidebar-menu-disabled {
        pointer-events: none;
        opacity: 0.6;
      }

      /* Allow the locked 'Create' menu item to open upgrade modal while keeping disabled visuals */
      &.wt-nav-own-strategy.sidebar-menu-disabled {
        pointer-events: auto; /* enable click events specifically for this item */

        .inner-item .item-content .sidebar-lock-icon {
          pointer-events: auto;
          cursor: pointer;
        }
      }

      .inner-item {
        height: 35px;
        align-items: center;
        cursor: pointer;
        color: ${({ theme }) => theme.sidebar.font.primary};
        display: flex;
        padding: 8px 16px;
        position: relative;

        .item-content {
          font-weight: 500;
          font-size: 16px;
          line-height: 140%;
          flex-grow: 1;
          flex-shrink: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-left: 10px;
          display: flex;
          align-items: center;

          .chevron {
            display: inline-flex;
            margin-left: auto;
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            transform-origin: center;

            &.open {
              transform: rotate(180deg);
            }

            svg {
              width: 16px;
              height: 16px;
              stroke: #a4a7ae;
              transition: stroke 0.2s ease;
            }
          }

          .move-back-btn img {
            margin-right: 8px;
            width: 9px;
            height: 100%;
          }
          .sidebar-lock-icon {
            width: 16px;
            height: 16px;
            margin-left: 6px;
            margin-top: 2px;
          }
        }

        .icon-wrapper {
          background-color: hsla(0, 0%, 100%, 0);
          display: inline-block;
          text-align: center;

          &.create-spacing {
            margin-bottom: 2px;
          }

          .icon {
            text-align: center;

            .move-back-btn {
              padding: 0;
              width: 30px;
              height: 30px;

              img {
                width: 9px;
                height: 100%;
              }
            }
          }

          &.open {
            .submenu {
              display: block;
            }
          }

          .submenu {
            display: none;
            padding: 6px 8px 8px 46px;
            list-style: none;

            li {
              margin: 4px 0;

              button {
                background: transparent;
                border: none;
                color: #414651;
                font-size: 14px;
                cursor: pointer;
                padding: 4px 0;
                text-align: left;
                width: 100%;

                &:hover {
                  color: #2258f1;
                }
              }
            }
          }
        }
      }

      .submenu {
        padding: 8px 12px 8px 37px;
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
          opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
          padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        .portfolio-list-container {
          max-height: 380px;
          overflow-y: auto;
          overflow-x: hidden;
        }

        .submenu-divider {
          height: 1px;
          background-color: #e3e8ef;
          margin: 8px 0;
        }

        .submenu-title {
          padding: 8px 0 8px 0;
          color: #1f2937;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0;
          opacity: 0;
          transform: translateY(-5px);
          animation: slideInFade 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0.1s forwards;
        }

        .submenu-loading,
        .submenu-empty {
          padding: 8px 0;
          color: #a4a7ae;
          font-size: 14px;
          opacity: 0;
          transform: translateY(-5px);
          animation: slideInFade 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0.15s
            forwards;
        }

        .account-item {
          margin: 4px 0;
          opacity: 0;
          transform: translateY(-10px);
          animation: slideInFade 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;

          &:nth-child(1) {
            animation-delay: 0.05s;
          }
          &:nth-child(2) {
            animation-delay: 0.1s;
          }
          &:nth-child(3) {
            animation-delay: 0.15s;
          }
          &:nth-child(4) {
            animation-delay: 0.2s;
          }
          &:nth-child(5) {
            animation-delay: 0.25s;
          }
          &:nth-child(6) {
            animation-delay: 0.3s;
          }

          button {
            display: flex;
            align-items: center;
            gap: 10px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: transparent !important;
            border: none !important;
            outline: none !important;
            box-shadow: none !important;
            padding: 6px 0;
            width: 100%;
            text-align: left;
            text-transform: none;
            letter-spacing: normal;

            .account-icon {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              object-fit: cover;
              transition: transform 0.2s ease;
            }

            > span {
              flex: 1;
              min-width: 0;
              display: block;
            }

            .account-broker {
              font-weight: 500;
              font-size: 14px;
              text-transform: none;
              transition: color 0.2s ease;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 100%;
              display: block;
            }

            &:hover {
              transform: translateX(4px);
              color: #2258f1;

              .account-icon {
                transform: scale(1.1);
              }
            }

            &:focus-visible {
              outline: none;
              box-shadow: none;
            }
          }

          &.selected button {
            color: #2258f1;
            font-weight: 600;

            .account-broker {
              font-weight: 600;
            }
          }
        }
      }

      &.open {
        .submenu {
          max-height: 500px;
          opacity: 1;
          padding: 8px 12px 8px 37px;
        }
      }
    }
  }

  /* Ensure tooltips for account nicknames show in single line */
  .tooltip {
    .tooltip-inner {
      white-space: nowrap;
      max-width: none;
    }
  }

  @media (max-width: 768px) {
    .close-menu {
      display: block;
    }
  }
`;
